import getErrorMessageFromStatus from 'utils/getErrorMessageFromStatus';
import { globalKey } from 'data/sharedKeys';
import AccountApi from './accounts.api';
import IamAccountApi from './iamAccounts.api';
import { raiseError } from '../messages/messages.actions';

export const LOAD_ACCOUNT_START = Symbol('LOAD_ACCOUNT_START');
export const LOAD_ACCOUNT_SUCCESS = Symbol('LOAD_ACCOUNT_SUCCESS');
export const LOAD_ACCOUNT_ERROR = Symbol('LOAD_ACCOUNT_ERROR');

export const UPDATE_ACCOUNT_START = Symbol('UPDATE_ACCOUNT_START');
export const UPDATE_ACCOUNT_SUCCESS = Symbol('UPDATE_ACCOUNT_SUCCESS');
export const UPDATE_ACCOUNT_RESET = Symbol('UPDATE_ACCOUNT_RESET');
export const UPDATE_ACCOUNT_ERROR = Symbol('UPDATE_ACCOUNT_ERROR');

export const CREATE_ACCOUNT_START = Symbol('CREATE_ACCOUNT_START');
export const CREATE_ACCOUNT_SUCCESS = Symbol('CREATE_ACCOUNT_SUCCESS');
export const CREATE_ACCOUNT_ERROR = Symbol('CREATE_ACCOUNT_ERROR');

export const CREATE_CCP_ACCOUNT_START = Symbol('CREATE_CCP_ACCOUNT_START');
export const CREATE_CCP_ACCOUNT_SUCCESS = Symbol('CREATE_CCP_ACCOUNT_SUCCESS');
export const CREATE_CCP_ACCOUNT_ERROR = Symbol('CREATE_CCP_ACCOUNT_ERROR');

export const CREATE_IAM_ACCOUNT_START = Symbol('CREATE_IAM_ACCOUNT_START');
export const CREATE_IAM_ACCOUNT_SUCCESS = Symbol('CREATE_IAM_ACCOUNT_SUCCESS');
export const CREATE_IAM_ACCOUNT_ERROR = Symbol('CREATE_IAM_ACCOUNT_ERROR');

const loadAccountStart = key => ({ type: LOAD_ACCOUNT_START, key });
export const loadAccountSuccess = (key, response) => ({ type: LOAD_ACCOUNT_SUCCESS, response, key });
const loadAccountError = key => ({ type: LOAD_ACCOUNT_ERROR, key });

const postAccountStart = key => ({ type: UPDATE_ACCOUNT_START, key });
const postAccountSuccess = key => ({ type: UPDATE_ACCOUNT_SUCCESS, key });
const postAccountError = key => ({ type: UPDATE_ACCOUNT_ERROR, key });

const createAccountStart = key => ({ type: CREATE_ACCOUNT_START, key });
const createAccountSuccess = key => ({ type: CREATE_ACCOUNT_SUCCESS, key });
const createAccountError = key => ({ type: CREATE_ACCOUNT_ERROR, key });

const createCcpAccountStart = key => ({ type: CREATE_CCP_ACCOUNT_START, key });
const createCcpAccountSuccess = key => ({ type: CREATE_CCP_ACCOUNT_SUCCESS, key });
const createCcpAccountError = key => ({ type: CREATE_CCP_ACCOUNT_ERROR, key });

const createIamAccountStart = key => ({ type: CREATE_IAM_ACCOUNT_START, key });
const createIamAccountSuccess = key => ({ type: CREATE_IAM_ACCOUNT_SUCCESS, key });
const createIamAccountError = key => ({ type: CREATE_IAM_ACCOUNT_ERROR, key });

export function postAccountReset(key) {
  return { type: UPDATE_ACCOUNT_RESET, key };
}

export function loadAccount(key) {
  return function loadAccountThunk(dispatch) {
    dispatch(loadAccountStart(key));
    AccountApi.getAccount()
      .then(response => dispatch(loadAccountSuccess(key, response)))
      .catch((error) => {
        dispatch(raiseError(error));
        dispatch(loadAccountError(key));
      });
  };
}

export function saveAccount(account, key) {
  return function saveAccountThunk(dispatch) {
    dispatch(postAccountStart(key));
    AccountApi.updateAccount(account, key)
      .then(() => dispatch(postAccountSuccess(key)))
      .catch((error) => {
        dispatch(raiseError(error));
        dispatch(postAccountError(key));
      });
  };
}


export function createIamAccount(account, key) {
  return function createIamAccountThunk(dispatch) {
    dispatch(createIamAccountStart(key));
    const promise = IamAccountApi.createAccount(account);
    promise.then(() => dispatch(createIamAccountSuccess(key)));
    promise.catch((error) => {
      const errorObject = new Error(getErrorMessageFromStatus(error.response.status));
      dispatch(raiseError(errorObject));
      dispatch(createIamAccountError(key));
    });
    return promise;
  };
}

export function createCcpAccount(account, key) {
  return function createCcpAccountThunk(dispatch) {
    dispatch(createCcpAccountStart(key));
    const promise = AccountApi.createAccount(account)
      .then((response) => {
        dispatch(createCcpAccountSuccess(key));
        dispatch(loadAccountSuccess(globalKey, response));
      });
    promise.catch((error) => {
      const errorObject = new Error(getErrorMessageFromStatus(error.response.status));
      dispatch(raiseError(errorObject));
      dispatch(createCcpAccountError(key));
    });
    return promise;
  };
}

export function createAccount(account, key) {
  return async function createAccountThunk(dispatch) {
    try {
      dispatch(createAccountStart(key));
      const iamAccountResponse = await createIamAccount(account, key)(dispatch);
      const newAccount = {
        ...account,
        accountName: iamAccountResponse.data.AccountName,
        fbpn: iamAccountResponse.data.Fbpn,
      };
      await createCcpAccount(newAccount, key)(dispatch);
      dispatch(createAccountSuccess(key));
    } catch {
      dispatch(createAccountError(key));
    }
  };
}
